import monkeyPatch from "./monkeyPatch.js";

/**
 * Erweitert alle Javascript-Map um einen Satz von Hilfsmethoden (Monkeypatching).
 * FUCK YOU ES6-Standards-Kommitee! Warum ist das nicht Teil des Standards !?!?!?!?!?!?!
 */
monkeyPatch(Map.prototype, {

    /**
     * ruf mapper(value,key) für jeden Eintrag der Map auf und baut eine Array mit den Rückgabewerten auf
     */
    map(mapper) {
        const list = [];
        this.forEach((value,key)=>{
            list.push(mapper(value,key));
        });
        return list;
    },

    reduce(mapper, startValue) {
        return Array.from(this).reduce( (accu, current) => mapper(accu, current[1]), startValue);
    },

    /**
     * sucht nach erstem Element für das predicate True ergibt und gibt ein KeyValuePair zurück
     * @param predicate
     * @returns Object with key and value
     */
    find(predicate) {
        let result;
        this.forEach((value,key)=>{
            if (result===undefined && predicate(value,key)){
                result={key:key,value:value};
            }
        });
        return result;
    },
    /**
     *  reverse Lookup to find a key, to a given value;
     * @param value
     */
    getKey(value){
        const r=this.find((v,k)=>v===value);
        return r===undefined?r:r.key;
    }

});

/**
 * Welcher Vollpfosten hatte diese glorreiche Idee: array.length aber map.size???????
 * Sowas ist einfach nur kognitiver Müll!
 * Das hier ist zwar nicht so performant, aber solche Fehler sind teilweise schwer zu finden,
 * daher lieber Bugfreiheit.
 * for the record: https://stackoverflow.com/questions/35038750/why-do-javascript-sets-maps-use-size-instead-of-length
 * Idioten!
 */
if (!Object.getOwnPropertyDescriptor(Map.prototype,'length')) {
    Object.defineProperty(Map.prototype, "length", {
        get() {
            return this.size;
        }
    });
}
